import * as React from "react";
import { Link } from "react-router";

import Medallion from "@/components/common/Medallion";
import type { Juz } from "@/lib/types";
import { toArabicDigits } from "@/lib/utils";

interface JuzsViewProps {
	juzs: Juz[];
}

const JuzsView: React.FC<JuzsViewProps> = ({ juzs }) => {
	return (
		<ul className="grid grid-cols-1 gap-3 py-6 sm:grid-cols-2 lg:grid-cols-3">
			{juzs.map((juz) => (
				<li key={juz.id} className="min-w-0">
					<Link
						to={`/${juz.page_start}`}
						className="pressable group flex h-full items-center gap-3.5 rounded-card bg-paper-50 p-4 shadow-card ring-1 ring-paper-300 transition-shadow [--press-scale:0.985] hover:shadow-card-hover hover:ring-gold-400/60"
					>
						<Medallion>{juz.number}</Medallion>
						<div className="min-w-0 flex-1">
							<h2 className="text-[15px] font-semibold text-ink">{juz.number}. džuz</h2>
							<p className="text-sm tabular-nums text-ink-muted">
								Stranice: {juz.page_start} - {juz.page_end}
							</p>
							<p className="mt-1.5 text-xs tabular-nums text-ink-subtle">
								Ukupno stranica: {juz.page_end - juz.page_start + 1}{" "}
								<span aria-hidden>·</span> {juz.number}/30
							</p>
						</div>
						<span
							aria-hidden
							lang="ar"
							dir="rtl"
							className="shrink-0 font-arabic text-[26px] leading-none text-gold-700"
						>
							الجزء {toArabicDigits(juz.number)}
						</span>
					</Link>
				</li>
			))}
		</ul>
	);
};

export default React.memo(JuzsView);
